import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    static get targets() {
        return ['value', 'input', 'category', 'documentType', 'error', 'uploadButton', 'uploadHint']
    }

    static values = {
        maxSize: { type: Number, default: 10 }
    }

    connect() {
    }

    display(event) {
        const file = event.target.files[0];

        if (file) {
            const minSize = 1024;
            const maxSize = (this.maxSizeValue || 10) * 1024 * 1024;

            if (file.size < minSize) {
                this.showError('Datei ist zu klein. Mindestgröße: 1 KB');
                event.target.value = '';
                return;
            }

            if (file.size > maxSize) {
                this.showError(`Datei ist zu groß. Maximale Größe: ${this.maxSizeValue || 10} MB`);
                event.target.value = '';
                return;
            }

            if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
                this.showError('Nur PDF-Dateien sind erlaubt');
                event.target.value = '';
                return;
            }
        }

        const fileName = event.target.value.split('\\').pop();
        this.valueTarget.innerHTML = fileName;

        if (this.hasErrorTarget) {
            this.errorTarget.style.display = 'none';
        }

        // showError() erzeugt ein eigenes Element (.file-error-message), das
        // NICHT identisch mit errorTarget ist. Ohne dieses Ausblenden blieb die
        // Meldung ("Datei ist zu klein") stehen, obwohl die neu gewaehlte Datei
        // gueltig ist.
        this.hideInlineError();

        // classList.remove() liefert undefined zurueck - die frueher hier
        // angehaengte .add(...)-Kette warf daher bei JEDER Dateiauswahl einen
        // TypeError ("Cannot read properties of undefined"). Ausserdem wirft
        // der Zugriff auf documentTypeTarget in Stimulus, wenn das Target
        // fehlt - deshalb hasDocumentTypeTarget pruefen.
        if (this.hasDocumentTypeTarget) {
            this.documentTypeTarget.classList.remove('hidden');
            this.documentTypeTarget.classList.add('animate__animated', 'animate__fadeIn');
        }

        this.awaitUpload(true);
    }

    // Solange eine Datei gewaehlt, aber noch nicht hochgeladen ist, ist
    // "Hochladen" die einzige sinnvolle Aktion. "Speichern & weiter" wird
    // gedaempft, weil ein Klick dorthin die gewaehlte Datei verwirft - der
    // haeufigste Grund fuer Bewerbungen ohne Dokument.
    awaitUpload(pending) {
        if (this.hasUploadHintTarget) {
            this.uploadHintTarget.classList.toggle('hidden', !pending);
        }

        if (this.hasUploadButtonTarget) {
            this.uploadButtonTarget.classList.toggle('ring-2', pending);
            this.uploadButtonTarget.classList.toggle('ring-offset-2', pending);
            this.uploadButtonTarget.classList.toggle('ring-amber-500', pending);
        }

        document.querySelectorAll('[data-apply-steps-next]').forEach((el) => {
            el.classList.toggle('opacity-50', pending);
        });
    }

    hideInlineError() {
        const errorElement = this.element.querySelector('.file-error-message');
        if (errorElement) {
            errorElement.style.display = 'none';
        }
    }

    showError(message) {
        let errorElement = this.element.querySelector('.file-error-message');
        if (!errorElement) {
            errorElement = document.createElement('div');
            errorElement.className = 'file-error-message text-red-600 text-sm mt-2';
            this.element.appendChild(errorElement);
        }
        errorElement.textContent = message;
        errorElement.style.display = 'block';

        this.awaitUpload(false);

        this.valueTarget.innerHTML = 'Keine Datei hochgeladen';
    }

    validate() {
        if (this.hasErrorTarget && this.inputTarget.files.length === 0) {
            this.errorTarget.style.display = 'block';
            return false;
        }
        return true;
    }
}
